<template>
  <div class="h-dialogContainer">
    <form id="noRealTaskDataExport">
      <div class="row">
        <div class="col-sm-6">
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
            <ejs-radiobutton :label='$t("Pm.today")' name="timeRangeForExport" :checked="true" value="0" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeRangeForExport" value="1" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeRangeForExport" value="2" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeRangeForExport" value="3" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.specified")' name="timeRangeForExport" value="4" :change="changeOfTimeRange"></ejs-radiobutton>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
            <ejs-datetimepicker :change='validateOfNoRealDataExport' name="startTime" :locale='locale' :format='dateFormat' :enabled='startTimeEnabled' v-model='startTime'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
            <ejs-datetimepicker :change='validateOfNoRealDataExport' name="endTime" :locale='locale' :format='dateFormat' :enabled='endTimeEnabled' v-model='endTime'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.measureCycle')}}</div>
            <ejs-dropdownlist :dataSource='dataSourceOfSampleTime' :fields='fieldsOfSampleTime' v-model='sampleTime'></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.measureObj')}}</div>
            <ejs-listview :dataSource='dataSourceOfMeasureObj' :showIcon='true' :fields="filedsOfMeasureObj" :select="measureObjSelected"></ejs-listview>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="h-col-inputBox-middle">
            <div class="h-inputLit">{{$t('Pm.counterList')}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="h-borderBox height-250">
            <NoRealTaskMeasureTreeForDataSearch ref="NoRealTaskMeasureTreeForDataExport"></NoRealTaskMeasureTreeForDataSearch>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import NoRealTaskMeasureTreeForDataSearch from '../tree/NoRealTaskMeasureTreeForDataSearch';
  import DateUtil from "../../../../util/DateUtil";
  import CommonUtil from "../../../../util/CommonUtil";
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: 'NoRealTaskDataExportDialog',
    props: [
      'selectNeId',
      'selectNeType'
    ],
    components: {
      NoRealTaskMeasureTreeForDataSearch
    },
    data() {
      return {
        locale: localStorage.getItem('locale'),
        startTimeEnabled: false,
        endTimeEnabled: false,
        startTime: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        endTime: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        dataSourceOfSampleTime: [
          {cycle: `5${this.$t('Pm.minutes')}`, value: 300000},
          {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
          {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
          {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
          {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
        ],
        fieldsOfSampleTime: {
          text: 'cycle',
          value: 'value'
        },
        sampleTime: 900000,
        filedsOfMeasureObj: {
          text: 'measureObjNameCH',
          value: 'measureObjCode',
        },
        dataSourceOfMeasureObj: [],
        measureObjCode: 1,
        formObjOfNoRealDataExport: '',
        optionsOfNoRealDataExportDialogValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            startTime: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTime: {
              required: [true, this.$t('Pm.endTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        }
      }
    },
    methods: {

      measureObjSelected(args) {
        this.measureObjCode = args.data.measureObjCode;
        this.$refs.NoRealTaskMeasureTreeForDataExport.getMeasureTreeForData(this.selectNeId,this.selectNeType,args.data.measureObjCode);
      },
      changeOfTimeRange(args) {
        switch (args.value) {
          case '0':
            this.startTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '1':
            this.startTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '2':
            this.startTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '3':
            this.startTime = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '4':
            this.startTime = '';
            this.endTime = '';
            this.startTimeEnabled = true;
            this.endTimeEnabled = true;
            break;
          default:
            break;
        }
      },
      getMeasureListForDataExport(neId,neTypeCode){
        const params = {
          neTypeCode,
          neId
        }
        this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskMeasureObjListForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
          this.dataSourceOfMeasureObj =response.data;
        });
      },
      bindValidateOfNoRealDataExport() {
        this.formObjOfNoRealDataExport = new FormValidator('#noRealTaskDataExport', this.optionsOfNoRealDataExportDialogValidation);
      },
      validateOfNoRealDataExport() {
        const formStatus = this.formObjOfNoRealDataExport.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      }
    },
    mounted() {
      this.bindValidateOfNoRealDataExport();
    }
  }
</script>

<style scoped>
  .h-dialogContainer .h-col-inputBox-left {
    margin-bottom: 18px;
    padding-left: 35px;
    padding-right: 10px;
  }

  .h-dialogContainer .h-col-inputBox-middle {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .h-dialogContainer .h-col-inputBox-right {
    margin-bottom: 18px;
    padding-left: 10px;
    padding-right: 35px;
  }

  .h-dialogContainer >>> .e-listview .e-list-item.e-active{
    background-color: #007bff;
    color: #fff;
  }
</style>
